import React, { useState } from "react";
import { Link } from "react-router-dom";
import NavigationHeader from "../../components/ui/NavigationHeader";
import { useAuth } from "../../contexts/AuthContext";

export default function Contact() {
  const { user, userProfile } = useAuth();
  const currentTier = userProfile?.subscription_tier || "free";


  const [copied, setCopied] = useState(false);

  const supportEmail = "support@immoiq.ca"; // change si tu veux

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // fallback: rien
    }
  };

  return (
    
    <div className="min-h-screen min-h-[100dvh] bg-background">
      <NavigationHeader
        user={{ name: user?.email?.split("@")[0] || "Utilisateur" }}
        subscriptionTier={currentTier}
      />
      <main className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-semibold text-foreground">Contact</h1>
        <p className="mt-2 text-muted-foreground">
          Une question, un bug, une suggestion? Écris-nous et on te répond dès que possible.
        </p>

        <div className="mt-8 rounded-xl border border-border bg-card p-6">
          <div className="flex flex-col gap-2">
            <div className="text-sm text-muted-foreground">Courriel de support</div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="text-lg font-medium text-foreground">{supportEmail}</div>
              <button
                onClick={copyEmail}
                className="px-3 py-2 rounded-lg border border-border bg-background hover:bg-muted transition text-sm"
                type="button"
              >
                {copied ? "Copié ✅" : "Copier"}
              </button>
            </div>

            <div className="mt-6 text-sm text-muted-foreground">
              Pour accélérer le support, ajoute :
              <ul className="list-disc pl-5 mt-2">
                <li>la page où ça arrive</li>
                <li>une capture d’écran</li>
                <li>les étapes pour reproduire</li>
                <li>ton navigateur / téléphone</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-6 text-xs text-muted-foreground">
          Note : ImmoIQ ne fournit pas de conseils financiers, juridiques ou fiscaux.
        </div>
      </main>
    </div>
  );
}
